import React from "react";
import { Link } from "react-router-dom";
import aiImage from "../../../assets/MS.png";
import strategyImage from "../../../assets/MS2.jpeg";

export default function MicrosoftServices() {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="relative h-[60vh] sm:h-[70vh] md:h-[800px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={aiImage}
            alt="Microsoft Services"
            className="w-full h-full object-cover sm:object-contain md:object-cover"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 sm:px-6">
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
            Microsoft Services
          </h1>
          <p className="text-sm sm:text-lg md:text-xl lg:text-2xl max-w-3xl mx-auto leading-relaxed">
            Implement Azure Cloud, Microsoft 365, Power Platform, and Copilot AI services
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
            {/* Image - Left Side */}
            <div className="flex-1 w-full">
              <img
                src={strategyImage}
                alt="Microsoft Services"
                className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Content - Right Side */}
            <div className="flex-1 w-full">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 text-pink-600 text-center lg:text-left">
                Microsoft Services
              </h2>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6 text-center lg:text-left">
                Implement Azure Cloud, Microsoft 365, Power Platform, and Copilot AI services.
              </p>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed text-center lg:text-left">
                Our Microsoft expertise helps organizations leverage the full potential of Microsoft's ecosystem to drive productivity, collaboration, and digital transformation.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Services Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 text-pink-600">
              Our Services
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-700 max-w-4xl mx-auto">
              Our services empower businesses to streamline operations, enhance customer experiences, and address common challenges such as inefficient processes and the need for digital transformation in an increasingly digital landscape.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white border-2 border-gray-300 rounded-lg p-6 hover:shadow-lg hover:bg-pink-50 transition-all duration-300 h-64 flex flex-col justify-between">
              <div>
                <h3 className="text-lg font-bold text-pink-600 mb-3 text-center">
                  SharePoint Development
                </h3>
                <p className="text-sm text-gray-600 text-center mb-4">
                  ALIF specialises in developing SharePoint solutions that enhance collaboration, document management, and organisational workflow automation.
                </p>
              </div>
              <Link to="/contact" className="bg-pink-600 text-white px-4 py-2 rounded text-sm font-semibold hover:bg-pink-700 transition-colors mx-auto">
                Learn More
              </Link>
            </div>
            
            <div className="bg-white border-2 border-gray-300 rounded-lg p-6 hover:shadow-lg hover:bg-pink-50 transition-all duration-300 h-64 flex flex-col justify-between">
              <div>
                <h3 className="text-lg font-bold text-pink-600 mb-3 text-center">
                  Digital Transformation
                </h3>
                <p className="text-sm text-gray-600 text-center mb-4">
                  ALIF guides businesses in adopting modern digital technologies and strategies to stay competitive in the digital age.
                </p>
              </div>
              <Link to="/contact" className="bg-pink-600 text-white px-4 py-2 rounded text-sm font-semibold hover:bg-pink-700 transition-colors mx-auto">
                Learn More
              </Link>
            </div>
            
            <div className="bg-white border-2 border-gray-300 rounded-lg p-6 hover:shadow-lg hover:bg-pink-50 transition-all duration-300 h-64 flex flex-col justify-between">
              <div>
                <h3 className="text-lg font-bold text-pink-600 mb-3 text-center">
                  Enterprise Content Management Systems
                </h3>
                <p className="text-sm text-gray-600 text-center mb-4">
                  ALIF implements robust Enterprise Content Management Systems (ECMS) to efficiently organise, store, and manage digital content.
                </p>
              </div>
              <Link to="/contact" className="bg-pink-600 text-white px-4 py-2 rounded text-sm font-semibold hover:bg-pink-700 transition-colors mx-auto">
                Learn More
              </Link>
            </div>
            
            <div className="bg-white border-2 border-gray-300 rounded-lg p-6 hover:shadow-lg hover:bg-pink-50 transition-all duration-300 h-64 flex flex-col justify-between">
              <div>
                <h3 className="text-lg font-bold text-pink-600 mb-3 text-center">
                  ERP Implementation (Microsoft Dynamics)
                </h3>
                <p className="text-sm text-gray-600 text-center mb-4">
                  ALIF seamlessly integrates Enterprise Resource Planning (ERP) systems, notably Microsoft Dynamics, to streamline business processes.
                </p>
              </div>
              <Link to="/contact" className="bg-pink-600 text-white px-4 py-2 rounded text-sm font-semibold hover:bg-pink-700 transition-colors mx-auto">
                Learn More
              </Link>
            </div>
            
            <div className="bg-white border-2 border-gray-300 rounded-lg p-6 hover:shadow-lg hover:bg-pink-50 transition-all duration-300 h-64 flex flex-col justify-between">
              <div>
                <h3 className="text-lg font-bold text-pink-600 mb-3 text-center">
                  Web Development
                </h3>
                <p className="text-sm text-gray-600 text-center mb-4">
                  ALIF designs and develops responsive, user-friendly websites that cater to the unique needs of businesses.
                </p>
              </div>
              <Link to="/contact" className="bg-pink-600 text-white px-4 py-2 rounded text-sm font-semibold hover:bg-pink-700 transition-colors mx-auto">
                Learn More
              </Link>
            </div>
            
            <div className="bg-white border-2 border-gray-300 rounded-lg p-6 hover:shadow-lg hover:bg-pink-50 transition-all duration-300 h-64 flex flex-col justify-between">
              <div>
                <h3 className="text-lg font-bold text-pink-600 mb-3 text-center">
                  Mobile Application Development
                </h3>
                <p className="text-sm text-gray-600 text-center mb-4">
                  ALIF crafts mobile applications for various platforms, enabling businesses to reach customers on smartphones and tablets.
                </p>
              </div>
              <Link to="/contact" className="bg-pink-600 text-white px-4 py-2 rounded text-sm font-semibold hover:bg-pink-700 transition-colors mx-auto">
                Learn More
              </Link>
            </div>
            
            <div className="bg-white border-2 border-gray-300 rounded-lg p-6 hover:shadow-lg hover:bg-pink-50 transition-all duration-300 h-64 flex flex-col justify-between">
              <div>
                <h3 className="text-lg font-bold text-pink-600 mb-3 text-center">
                  IoT (Internet of Things)
                </h3>
                <p className="text-sm text-gray-600 text-center mb-4">
                  ALIF leverages IoT technology to connect and manage devices, collect and analyse data, and automate processes.
                </p>
              </div>
              <Link to="/contact" className="bg-pink-600 text-white px-4 py-2 rounded text-sm font-semibold hover:bg-pink-700 transition-colors mx-auto">
                Learn More
              </Link>
            </div>
            
            <div className="bg-white border-2 border-gray-300 rounded-lg p-6 hover:shadow-lg hover:bg-pink-50 transition-all duration-300 h-64 flex flex-col justify-between">
              <div>
                <h3 className="text-lg font-bold text-pink-600 mb-3 text-center">
                  Integrated Management Services (IMS)
                </h3>
                <p className="text-sm text-gray-600 text-center mb-4">
                  ALIF helps streamline and optimise organisational processes through Integrated Management Services.
                </p>
              </div>
              <Link to="/contact" className="bg-pink-600 text-white px-4 py-2 rounded text-sm font-semibold hover:bg-pink-700 transition-colors mx-auto">
                Learn More
              </Link>
            </div>
            
            <div className="bg-white border-2 border-gray-300 rounded-lg p-6 hover:shadow-lg hover:bg-pink-50 transition-all duration-300 h-64 flex flex-col justify-between">
              <div>
                <h3 className="text-lg font-bold text-pink-600 mb-3 text-center">
                  Microsoft Azure AI & Consulting Services
                </h3>
                <p className="text-sm text-gray-600 text-center mb-4">
                  Transform your data into actionable insights with ALIF's expert AI & data analytics solutions.
                </p>
              </div>
              <Link to="/contact" className="bg-pink-600 text-white px-4 py-2 rounded text-sm font-semibold hover:bg-pink-700 transition-colors mx-auto">
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}